import axios from 'axios';

let prefix = "/vendor"

const VendorApi = {
	
	getVendorList(payload){
		return axios.get( prefix + "/list", {params: payload})
	},
	getVendorById(id, payload){
		return axios.get( prefix + "/get/" + id, {params: payload})
	},
	createVendor(payload){
		return axios.post( prefix + "/create", payload)
	},
	updateVendor(payload){
		return axios.post( prefix + "/update", payload)
	},
	archiveVendor(payload){
		return axios.delete( prefix + "/delete", {params: payload})
	},
	updateVendorStatus(payload){
		return axios.put( prefix + "/update-status", payload)
	},
	updateCommission(payload){
		return axios.post( prefix + "/update-commission", payload)
	},
	exportVendor(payload){
		return axios.get( prefix + "/export", {params: payload, responseType: 'blob'})
	},
	// getVendorStatusRef(payload){
	// 	return axios.get( prefix + "/status-list", {params: payload})
	// },
	getVendorNotificationSettings(vendor_id){
		return axios.get(prefix + "/notification-setting/get", {params: {vendor_id}})
	},
	updateVendorNotificationSettings(payload){
		return axios.post(prefix + "/notification-setting/update", payload)
	},

}

export default VendorApi;